var _style, _g, _g2, _g3, _g4, _path, _g5, _path2, _g6, _g7, _g8, _g9, _g10, _path3, _g11, _line, _path4, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _polygon, _polygon2, _g20, _g21, _g22, _g23, _g24, _path5, _g25, _g26, _g27, _g28, _path6, _path7, _g29, _g30, _g31, _path8, _path9, _g32, _g33, _g34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 962.7 542",
    style: {
      enableBackground: "new 0 0 962.7 542"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EDF3F9;}\n\t.st1{fill:none;stroke:#99BFE3;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3.5,3.5;}\n\t.st2{fill:none;stroke:#99BFE3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;stroke:#99BFE3;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:#2D2D2D;}\n\t.st5{fill:#FFB9A9;}\n\t.st6{fill:#E56767;}\n\t.st7{fill:none;stroke:#2D2D2D;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st8{fill:#031628;}\n\t.st9{fill:none;stroke:#EA8F86;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st10{fill:#008080;}\n\t.st11{fill:none;}\n\t.st12{fill:#FC9854;}\n\t.st13{fill:#4DA3F7;}\n\t.st14{fill:#3F111D;}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:none;stroke:#A84545;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:#C96947;}\n\t.st18{fill:#611223;}\n\t.st19{fill:#4063D9;}\n\t.st20{fill:#006663;}\n\t.st21{fill:none;stroke:#262A82;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st22{fill:#BADFF4;}\n\t.st23{fill:#404058;}\n\t.st24{fill:#000715;}\n\t.st25{fill:#A35138;}\n\t.st26{fill:none;stroke:#77331E;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{fill:none;stroke:#A89892;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st28{fill:none;stroke:#4DA3F7;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st29{fill:none;stroke:#AF3519;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M600,533.3c0,0,27.4-85.9,149-31.8c48.7,21.6,64.6,5.5,81,3.5c25.6-3.1,36.2,13.4,43.5,28.3H600z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M385.3,533.3h73.6c0,0-41.7-75.8-99.9-76.5c-59.2-0.8-76.4,37.3-103,40.5c-34.8,4.1-53.6-18.6-78.8-16.7 c-50.8,3.7-75,52.7-75,52.7H385.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M594.2,34.3h109.4c27.2,0,49.2,20.9,49.2,46.8l0,0c0,25.9-22,46.8-49.2,46.8H210.4 c-34.7,0-62.8,26.8-62.8,59.8l0,0c0,33,28.1,59.8,62.8,59.8h601.1c34.9,0,63.3,26.9,63.3,60.3l0,0c0,33.2-28.3,60.3-63.3,60.3 H117.6c-20,0-36.2,15.4-36.2,34.5l0,0c0,19,16.2,34.5,36.2,34.5h193.6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 170.5,
    cy: 291.3,
    rx: 17.3,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 792.1,
    cy: 336.5,
    rx: 10.3,
    ry: 9.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 133.6,
    cy: 255.5,
    rx: 8.9,
    ry: 8.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 770.1,
    cy: 102,
    rx: 4.7,
    ry: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.3,25.7c0,2.5-2.1,4.5-4.7,4.5s-4.7-2-4.7-4.5c0-2.5,2.1-4.5,4.7-4.5C308.2,21.2,310.3,23.2,310.3,25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M835.9,285c0,2.5-2.1,4.5-4.7,4.5c-2.6,0-4.7-2-4.7-4.5c0-2.5,2.1-4.5,4.7-4.5 C833.8,280.5,835.9,282.5,835.9,285z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M168.6,409c0,2.5-2.1,4.5-4.7,4.5c-2.6,0-4.7-2-4.7-4.5c0-2.5,2.1-4.5,4.7-4.5 C166.5,404.5,168.6,406.6,168.6,409z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M794.6,428.6c0,2.5-2.1,4.5-4.7,4.5c-2.6,0-4.7-2-4.7-4.5s2.1-4.5,4.7-4.5 C792.5,424.1,794.6,426.1,794.6,428.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M715.1,64.9c0,4.1-3.5,7.5-7.9,7.5c-4.3,0-7.9-3.3-7.9-7.5c0-4.1,3.5-7.5,7.9-7.5 C711.5,57.4,715.1,60.7,715.1,64.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.4,
    y1: 380.6,
    x2: 148.6,
    y2: 380.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 845.9,
    y1: 392.1,
    x2: 870.1,
    y2: 392.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 597.4,
    y1: 110.2,
    x2: 634.5,
    y2: 110.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 158.4,
    y1: 355,
    x2: 170.5,
    y2: 355
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 628.8,
    y1: 98,
    x2: 640.9,
    y2: 98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 261.4,
    y1: 53.4,
    x2: 273.5,
    y2: 53.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 282.6,
    y1: 64.9,
    x2: 294.7,
    y2: 64.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.4,533.9c-16.7-30.8-41.7-41.9-52.6-57.2c-3.3-4.7-6.1-9.6-6.3-14.8s2.8-10.6,8.5-12.5 c5-1.6,10.9-0.5,16.1,1.3c16.1,5.6,28.3,17.4,35.7,30.2c7.3,12.9,14.6,32.9,13.4,52.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.9,451.9c0,0,51.7,25.2,63.3,82.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M204.5,533.9c-0.1-29.7-7.3-52.2-16.3-78c-4.5-12.9-10.1-25.9-13.5-38.9c-2.4-9.5-4.4-21.5,1.4-29.1 c6.6-8.8,19.2-5,28.4,0.9c11,6.9,18.8,17.8,23.8,29c8.8,19.8,10.3,41.6,10.5,61.7c0.2,18.5-3.6,38.9-8.2,54.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M186.2,382.7c0,0,38.8,66.4,31.8,151.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M316.9,533.9c-2.7-21.6-2.4-45.3,5.2-65.9c7.6-20.6,23.5-39,44.9-46.6c3.7-1.3,8.1-2.2,11.4-0.2 c3.1,1.9,4.1,5.6,4.6,9c2.3,17-4.6,34-13.3,49c-8.7,15-19.3,38.4-25.3,54.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M596.3,533.9c-2-31.3,1.7-69.7,12.4-94.2c8.3-19.1,22.2-37,41-48.4c13.6-8.2,39.6-21.2,53.3-6.9 c20.2,21-24.1,54.6-35.8,69.2c-19.6,24.1-35.7,50.3-42.2,80.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M552.7,533.9c-2.3-26.1-19.3-50.5-36.5-71c-17.1-20.5-35.5-41.5-41.5-67.1c-1.8-7.9-2.2-16.7,2.3-23.4 c7-10.4,22.6-11.9,35.1-8.4c17.2,4.8,31.5,16.7,41.4,30.9c9.9,14.2,15.7,30.7,19.9,47.2c7.5,29.3,10.2,61.7,8.1,91.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M768.6,533.9c1.4-38,8.8-69.2,38.2-97.2c9.2-8.8,26.4-20.2,41.9-13.6c7.7,3.2,7.8,14.5,4.2,21.1 c-9.8,18.2-52.1,39.2-67.7,89.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M742.3,533.9C729,443.1,753.4,406.5,767.4,393c9.3-8.9,26.9-21.7,42.6-12.3c18.7,11.2,8.3,36.7-3.1,56 c-13.1,22.2-30.7,56.2-33.6,97.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M795.1,533.9c3-14.9,17.9-47.2,40.2-57.3c5.7-2.6,13-3.2,19.1-1.5c5.6,1.5,9.7,6.5,10.4,11.9 c0.9,6.5-2.8,12-8,16c-12.6,9.5-27.5,18.8-38.8,31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M378.5,421.3c0,0-39.8,40.1-46.7,112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M484.7,365.7c0,0,66.9,48.6,86.1,168.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M605.8,534.6c0,0,12.8-99.6,97.2-150.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M809.9,380.9c0,0-55,44.9-54.3,153.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M777.7,533.9c7-38.3,28.2-75.1,71-110.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M805.4,533.9c0,0,16-36.9,54-56.6"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 533.3,
    className: "st2",
    width: 817.6,
    height: 1.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "750.7,534.6 709.8,534.6 710,529.6 750.9,529.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "746.4,479.7 747.4,514.1 745.5,529.6 717.3,512.7 715.6,475.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M717.3,512.7c0,0-4.1,9.9-5.9,12.6c-1.8,2.8-1.5,5.4-1.5,5.4s38.7,0,40.9,0c0.7-4.2-3.4-18-3.4-18 S725,514.1,717.3,512.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 727.4,
    y1: 516,
    x2: 737.1,
    y2: 516
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 727,
    y1: 519.3,
    x2: 737.4,
    y2: 519.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 726.6,
    y1: 522.6,
    x2: 737.8,
    y2: 522.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M665.3,111.1c1,5.5,1.8,11,7,14.4c2.8,1.8,6.1,2.7,9.3,3c2.7,0.2,5.5,0.1,8.1-0.6c2.6-0.7,5-2.1,7.3-3.4 c1.7-0.9,3.5-2,4.1-3.9c0.3-0.9,0.3-1.9,0.5-2.8c0.3-1.5,1.3-2.8,2.3-4c1.9-2.5,3.7-5.2,3.8-8.3c0-1.3-0.2-2.5-0.6-3.7 c-1.2-3.7-3.8-6.8-6.8-9.2c-3-2.5-6.4-4.3-9.8-6.1c-1.6-0.8-3.2-1.7-4.9-2s-3.5-0.1-5.2,0.2c-4.4,0.7-8.9,2-12.5,4.7 c-2,1.5-3.7,3.4-4.5,5.7c-1.1,3.2-0.3,6.7,0.7,9.9C664.6,107.1,664.9,109.1,665.3,111.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M681.6,533.6v-2.9h-54.4c-1.9,0-3.6-1-4.5-2.6l-0.3-0.1v4.7c0,0.2,0.1,0.3,0.2,0.5l0.1,0.1 c0.8,0.8,1.8,1.3,3,1.3h55C681.2,534.6,681.6,534.2,681.6,533.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M683.4,473.9l-3.5,40l-0.9,15.7h-53c-1.2,0-2.2-1-2.2-2.2l0,0c0-0.9,0.6-1.7,1.4-2.1l24.3-11.4l-2.2-44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M649.6,511.3l-25.7,14c-0.9,0.4-1.6,1.4-1.6,2.6l0,0c0,1.5,1.6,2.8,2.9,2.8h56.4l-1.7-17.1 C680,513.6,659.9,517.1,649.6,511.3z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 634.8,
    y1: 519.3,
    x2: 637.8,
    y2: 524.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 637.8,
    y1: 517.7,
    x2: 641,
    y2: 523
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 641,
    y1: 516,
    x2: 644.2,
    y2: 521.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M608.8,166.2l23,22.7l63.5,46.6L683.8,250c0,0-40.4-16.4-70.6-35.2c-10.9-6.8-32.8-30.3-32.8-30.3"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M688.9,232.6c3.7,1.8,10.8,4.7,14.5,6.5c2.2,1.1,5.9,3.2,5.8,4.2c-0.5,2.7-6.2-1.8-6.4-0.4 c-0.1,0.8,4.7,3,7.1,4.1c2.2,1,5,2.6,4.9,4.1c-0.2,1.9-12.5-3.7-12.5-3.7s12.7,6.5,12.4,8.1c-0.4,2.3-13.2-4.1-13.2-4.1 s10.7,5.7,10.4,7.4c-0.3,1.7-8.1-3.2-11.5-4.4c2.3,1.5,8.8,5.9,7.9,6.8c-0.8,0.8-5.5-1.6-6.6-2.1c-11.3-4.6-18.9-9.5-18.9-9.5"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M688.6,238.8c0,0,4.7,4.4,9.6,3.6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M626.7,171.8c0,0-22.7,28.2-30.4,36.2c-6.1,6.5-41.5,14-41.5,14l-1.2,17.9c9.5,0,51.9-0.6,70.2-18.9 c15.1-15.1,33.7-38.4,33.7-38.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M564.1,221c-4.6,0.2-10.8,0.7-15.4,0.7c-2.2,0-6.8,0.1-7.3,1c-0.9,1.8,5.7,1.5,5.3,2.8 c-0.3,0.8-5.2,0.6-7.6,0.3c-2.2-0.2-4.9-0.5-5.6,0.7c-0.6,1.1,12.2,2.8,12.2,2.8s-13.6-0.5-14.1,0.9c-0.8,2.1,14,2.6,14,2.6 s-12.8-0.2-13.4,1.4c-0.6,1.6,9.5,1.7,13.5,2.1c-2.4,0.1-11.4,0-11.8,1.1c-0.4,1.1,4.2,2.1,5.4,2.2c7.1,0.6,21.2,0.2,21.2,0.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M548.5,235.7c0,0,5-6.4,11.5-6.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 600,
    y1: 204,
    x2: 620.1,
    y2: 179.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 624.1,
    y1: 221,
    x2: 644.9,
    y2: 199
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M642.8,262c-1.7,2.3,0.2,244.1,0.2,244.1h42L698.7,324c0,0,4.4-40.2-6.4-75.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M740.4,262c3.6,4.9,14.3,244.1,14.3,244.1h-42l-23-182.1c0,0-4.4-40.2,6.4-75.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M695.2,368.1c0,0-6.6-71.2-6.6-91.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M680.6,276.7c0,0,1.1,27.5,2.6,34.1c0.6,2.9,7,2.3,7,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M750.2,506.1c0,0-11.1-210.7-17.9-231.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M714.8,280.3c0,0,4,10.7,7.1,13.8c3.1,3.1,13.4,2.1,13.4,2.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 681.6,
    y1: 506.1,
    x2: 693.6,
    y2: 349.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M642.2,293c0,0,8.6,0.8,10.9-1.1c3.1-2.6,8.7-9.5,8.7-9.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M683.2,138.7c0,0-13.2-7.1-34,5c-10.5,6-24.2,21.4-34,38.6c4,6.7,29.2,26.1,38.7,25.2 c7.5-9.6,15.7-38.8,15.7-38.8"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M644.3,163.9l-5.1,118.6l108.8-2.2c-0.9-26-9.8-90.7-15.7-119.9c-21-26.5-46.8-26.7-46.8-26.7l-20.1,12.4 L644.3,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M642.9,202c0,0,1.4-25.2,1.4-38.2"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M739.4,145.7c0,0,26.5,17.7,43.3,11.5c12.3-4.5,37.5-42.3,37.5-42.3l19.5,8.3c-5.1,9.9-29.7,66.5-60.3,68.6 c-25.6,1.8-55.3-13.2-55.3-13.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M814.1,124.2c2.6-4.7,6.5-11.1,9-15.8c1.2-2.3,3.7-7.1,4.9-7.1c2.3,0-1.5,6.8,0.1,7c1,0.1,3.4-5.2,4.4-7.9 c0.9-2.4,2-5.5,3.8-5.5c1.5,0-3.6,14.3-3.6,14.3s6.7-14.6,8.5-14.4c2.6,0.3-4.7,16.2-4.7,16.2s6.7-13.6,8.6-13.3 c2,0.3-3.3,10.9-5,15.3c1.4-2.5,6.1-12,7.5-11.8s-0.1,5.5-0.6,6.8c-3.2,7.7-11.1,22.4-11.1,22.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M837.9,115.6c0,0-9.4,1.9-12.5,8.8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M691.7,136c0,0,23.7-3.5,47.8,8.2c18.1,8.8,21.1,10.9,21.1,10.9l-14,34.4l-39.3-17.2"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M670.8,107.2c-1-1-2.6-0.9-3.6,0c-1.1,1-1.3,3-1,4.4c0.4,2.2,2.5,4.7,5,3.9c0.9-0.3,1.7-1,2-1.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M699.1,107.9c0.1-0.1,0.2-0.2,0.3-0.3c0.9-0.7,2.3-0.4,3,0.5s0.9,2.1,0.7,3.2c-0.2,1.2-0.7,2.5-1.6,3.3 c-0.9,0.9-2.3,1.3-3.5,0.9c-0.9-0.3-1.7-1-2-1.9"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M674.8,122.2l12.9-17.5l6.8,15.8l1.1,16.6c-4.4,9.5-18.3,7.4-20.6,1.8L674.8,122.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M671,96.1c-2.5,6.4-1.6,29.4,3.5,32.4c5.1,3,16.2,2.3,19.8-1.4c3.1-3.2,8-22.5,3.6-27.6 C693.5,94.3,674.5,87,671,96.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M696.9,84.3c-1.4-3.1-4.5-5.2-7.8-5.8s-6.9,0.4-9.6,2.4c-1.6,1.2-3,2.7-4.9,3.5c-2.2,0.9-4.6,0.5-6.9,0.5 c-2.3,0-4.9,0.4-6.2,2.3c-0.9,1.3-1,3-0.9,4.5c0.1,2.3,0.6,4.7,1.8,6.7s3.3,3.6,5.6,3.8c3,0.3,5.7-1.6,8.5-2.8 c2.7-1.2,5.5-2,8.2-3.3c2.6-1.2,5-1.3,7.5,0.2c2.3,1.4,3.9,3.5,5.8,5.4c1.2,1.2,2.5,2.4,4.2,2.9c1.7,0.4,3.7-0.3,4.3-1.9 c0.4-1.1,0.1-2.3-0.2-3.4c-0.4-1.6-0.8-3.2-1.2-4.8c-0.4-1.5-0.8-3.1-1.7-4.4c-0.7-1.1-1.6-1.9-2.6-2.6c-0.9-0.6-2.2-0.8-3-1.6 C697.4,85.5,697.2,84.9,696.9,84.3L696.9,84.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M677.7,130.1c0,0,10.3,1.5,15-2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M682.5,108.7c0,0-2.8,6.7-1.7,8.4s4,0.7,4,0.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M688.6,108.7c-0.2,0.4-0.2,1-0.2,1.3c-0.1,0.6,0.5,1,1.1,0.9c1.1-0.2,1.1-2.7-0.2-2.7 C688.9,108.2,688.7,108.4,688.6,108.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M674,108c-0.2,0.4-0.2,1-0.2,1.3c-0.1,0.6,0.5,1,1.1,0.9c1.1-0.2,1.1-2.7-0.2-2.7 C674.3,107.6,674.1,107.8,674,108z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M678,120.7l9.1-0.2c0,0,0.9,5.3-4.6,5.2C677.6,125.6,678,120.7,678,120.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M687.4,105.3c1.7,0.2,3.5,0.7,4.9,1.5c0.2-0.1,0.7-0.8,0.5-1.3c-0.2-0.4-2.8-1.6-5.2-1.7 C687.7,103.8,687.1,105.1,687.4,105.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M676.4,105c-1.2-0.1-2.5,0.2-3.5,0.7c-0.1-0.1-0.4-0.8-0.2-1.2c0.1-0.4,1.9-1.1,3.7-0.9 C676.4,103.6,676.7,104.8,676.4,105z"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st16",
    x1: 736.9,
    y1: 186,
    x2: 714.8,
    y2: 175.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M468.4,162.8c0,0,15.7,15.6,21.8,15c10.1-1.1,66.6-35.4,66.6-35.4l6.4,23.2c0,0-42.4,45.9-67.6,48.7 c-21.8,2.5-51.1-23.6-51.1-23.6"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M567.6,94.2c2.4,1,4,3.5,4.6,6s0.4,5.2,0.2,7.8c-0.1,0.7-0.1,1.5,0,2.3c0.6,3.5,5.3,4.8,6.5,8 c0.4,0.9,0.4,2,0.4,3c0.1,1.9,0.2,5.6,0.2,5.6s-16.5,1.3-26.3,1.1"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "496,534.6 536.9,534.6 536.6,529.6 495.7,529.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "500.2,479.7 499.2,514.1 501.2,529.6 527.9,512.7 531.1,475.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M527.9,512.7c0,0,5.5,9.9,7.3,12.6c1.8,2.8,1.5,5.4,1.5,5.4s-38.7,0-40.9,0c-0.7-4.2,3.4-18,3.4-18 S520.2,514.1,527.9,512.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 519.2,
    y1: 516,
    x2: 509.5,
    y2: 516
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 519.7,
    y1: 519.3,
    x2: 509.2,
    y2: 519.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 520,
    y1: 522.6,
    x2: 508.9,
    y2: 522.6
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M557.5,533.6l-0.2-2.9h54.4c1.9,0,3.5-1,4.4-2.6l0.3-0.1l0.2,4.7c0,0.2,0,0.3-0.2,0.5l-0.1,0.1 c-0.7,0.8-1.8,1.3-2.9,1.3h-55C558,534.6,557.6,534.2,557.5,533.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M559.3,479.7l0.1,34.1l0.5,15.8h53c1.2,0,2.2-1,2.1-2.2l0,0c0-0.9-0.7-1.7-1.5-2.1l-24.9-11.4l5.6-38.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M588.9,511.7l25.9,13.5c1,0.4,1.6,1.4,1.7,2.6l0,0c0.1,1.5-1.4,2.8-2.8,2.8h-56.4l1.7-17.2 C559.1,513.5,578.8,517.6,588.9,511.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 603.4,
    y1: 519.3,
    x2: 600,
    y2: 525.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 599.1,
    y1: 517.1,
    x2: 595.8,
    y2: 523.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 594.9,
    y1: 514.9,
    x2: 591.5,
    y2: 521.2
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M554.6,134.8c0,0,25.1,3.2,36.1,12c11.1,8.8,27.6,26.6,27.6,26.6L595.6,202l-20.5-22.2"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M577.3,223.4l10.5,9.6c2.1,6.8,17.3,23.1,20.7,74.7c3.7,57.1-3.5,176.6-3.5,176.6h-49l-2.6-203l-1.9-73.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M518.8,228.8c-3.5,9.4-16.4,29.3-22,56.6c-8.6,42.2-1.1,199-1.1,199h41.6l24.3-203.9c0,0,2.2-18.1,1.1-48.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M555.2,345.9c1-20.2,6.6-85.8,7.5-113.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M531.6,228.8c0,0-18.2,22-23.3,53.9c-4.4,26.9-3.3,201.6-3.3,201.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M547.3,232.3c0,0-4.3,16.1-28.9,18.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M595.7,249c0,0-17.6-9.5-21.1-16.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M569.9,234.7c0,0-0.8,25.7-3,27.9c-2.1,2.2-6.7,2.8-6.7,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M564.7,484.1c0,0-4.3-152.3-6.5-181.6"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M508.5,158.1c4.8-7.5,30.4-22.5,30.4-22.5c8.6-1.1,18.6-0.5,18.6-0.5s14.5,11.7,24.4,25.3 c8.2,7.9,11.5,13.9,11.6,22.1c0.1,5.6-2.5,10.3-3.8,18.8c-1.4,9.2-1.8,31.8-1.8,31.8c-15.6,5.8-47.3,5.1-70.5-0.7 C514.3,210.9,503.7,165.6,508.5,158.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M581.8,160.4c8.2,7.9,11.5,13.9,11.6,22.1c0.1,5.6-1.7,8.5-2.9,14"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M556.3,181.2l-3.6-39.7L556.3,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M549.5,153.2c0,0.4,0.4,0.7,0.8,0.7s0.7-0.3,0.7-0.7s-0.4-0.7-0.8-0.7C549.8,152.4,549.5,152.8,549.5,153.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M550.7,166.2c0,0.4,0.4,0.7,0.8,0.7c0.4,0,0.7-0.3,0.7-0.7s-0.4-0.7-0.8-0.7 C551,165.4,550.7,165.7,550.7,166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M551.9,179.1c0,0.4,0.4,0.7,0.8,0.7c0.4,0,0.7-0.3,0.7-0.7s-0.4-0.7-0.8-0.7 C552.2,178.4,551.9,178.7,551.9,179.1z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M494.7,164c0,0-29.6,26-35.6,30.5c-5.9,4.4-56.8,30-56.8,30l4.5,14.7c0,0,57.3-13.3,74.7-23.6 c14.1-8.3,41.1-32.1,41.1-32.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M538,135.9c0,0-13.2,1.8-27.7,10.4c-10.5,6.3-28.8,27.6-28.8,27.6l27,26.9l27.4-24.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 512.3,
    y1: 197.4,
    x2: 528.7,
    y2: 182.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M410,220.6c-3.9,1.2-11.1,2.9-15,4.1c-2.3,0.7-6.2,2.1-6.1,3.2c0.2,2.8,6.3-0.8,6.4,0.7 c0.1,0.9-4.9,2.2-7.4,2.9c-2.3,0.6-5.2,1.8-5.2,3.3c0,2,12.7-1.6,12.7-1.6s-13.2,4.3-13.1,5.9c0.2,2.4,13.5-1.9,13.5-1.9 s-11.2,3.9-11.1,5.6c0.1,1.8,8.3-1.3,11.8-2c-2.4,1.1-8.8,3.2-8.7,4.5c0.1,1.3,5.1,0.5,6.3,0c11.6-4.4,20.3-8.7,20.3-8.7"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M409.7,226.8c0,0-5.1,3.6-9.9,2"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M556.1,122.2l1.4,13.8c0,0,2.7,5.4-7.7,5.8c-8,0.2-11-6.2-11-6.2l3.8-21.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st5",
    d: "M567.4,91.5c2.8,8.9,6.2,27.2-3.9,32.5c-2.3,1.2-5.9,0.9-9.5-0.7c-7.9-3.5-12.9-9.8-14.3-15.3 C537.9,101.1,556.1,76.3,567.4,91.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M527.3,94.7c-1.3,1-3,1.6-4.1,2.9c-2.3,2.6-2.8,6.7-1.2,9.8c0.6,1.1,1.5,2.2,1.4,3.5 c-0.1,1.6-1.5,2.8-2.8,3.8c-5.8,4.3-3.3,13-3.3,13s16.5,0.8,26.4,0.1c0.1-5.6-1.3-11.8,0.3-17.1s4.6-10.4,9.2-13.5 c2.2-1.5,5-2.8,5.6-5.5c4.2,1.9,8.1,4.4,11.5,7.6c1.8-3.4,1.9-7.8,0-11.2c-1.1-1.8-4.2-4.7-7.2-5.2c-6-6-19-5.5-26.5-0.5 C530.8,86.1,530.9,92,527.3,94.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st9",
    d: "M561.9,105.3c0,0,3.7,5.8,2.9,7.1c-0.7,1.3-3.7,0.6-3.7,0.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_36_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st8",
    d: "M554,105.3c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6-0.2,1.2-0.2,1.9c0,1.1,1.8,1,1.7-0.1 c-0.1-0.7-0.2-1.4-0.5-2C554.6,104.7,554.3,104.9,554,105.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_34_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st8",
    d: "M566.1,103.9c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.7,0,1.2,0.2,1.9c0.2,1,1.9,0.6,1.6-0.4 c-0.2-0.6-0.4-1.3-0.8-1.9C566.6,103.2,566.3,103.5,566.1,103.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st8",
    d: "M548.6,104.5c0,0-0.1-0.5,0.2-1.3c0.2-0.7,0.9-1.6,1.7-2.1c0.9-0.6,2-0.8,2.8-0.6 c0.4,0.1,0.7,0.3,0.9,0.4c0.2,0.1,0.3,0.2,0.3,0.2s-0.1,0-0.3,0s-0.5,0.1-0.8,0.2c-0.6,0.2-1.3,0.5-2,1c-0.7,0.4-1.3,0.9-1.9,1.4 c-0.2,0.2-0.5,0.4-0.6,0.6C548.7,104.5,548.6,104.5,548.6,104.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    className: "st8",
    d: "M563.4,100.9c0,0,0-0.1,0.1-0.2c0.1-0.1,0.2-0.4,0.5-0.5c0.5-0.4,1.4-0.5,2.1-0.3 c0.8,0.2,1.4,0.7,1.8,1.2c0.3,0.5,0.3,0.9,0.3,0.9s-0.1,0-0.3-0.1c-0.1-0.1-0.4-0.1-0.6-0.2c-0.5-0.2-1-0.3-1.6-0.5 c-0.5-0.1-1.1-0.3-1.5-0.3C563.9,100.9,563.4,100.9,563.4,100.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M546.7,119c0,0,2.5,3.9,9.7,5.9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M546.2,109.4c-0.8-3.4-4.3-2.9-5.2-2.2c-0.7,0.5-0.9,1.4-1,2.2c-0.2,2.1,0.6,4.3,2.1,5.9 c0.5,0.6,1.2,1,1.9,1.3c2.1,0.6,3.4-0.9,3.4-2.7"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M565.2,115.5h-9.9c0,0,1,5.2,5.8,5.2C565.3,120.8,565.2,115.5,565.2,115.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "539.4,132.3 552.7,141.5 547.8,150.4 536.4,136.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "557.3,132.6 552.7,141.5 556.8,149.5 560.9,135.5  "
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "536.9,490.9 494.3,490.9 494.3,480.1 538.4,480.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st22",
    points: "605.3,490.9 555,490.9 555,480.1 605.7,480.1 "
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M569.6,137.7c1.9,3.4,10.4,8.9,11.7,8.6c1.3-0.3-1.6-3.9-1.9-4.8c2.9,0.8,5.3,1.9,7,3 c2.2,1.3,4.6,2.8,6.7,4.3c-1-2.6-4-6.6-5.3-7.6C582.9,137.5,575.7,135.7,569.6,137.7"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M411,130.9c0,0,22-5.8,41.2,10c15.9,13.1,27.2,29.5,27.2,29.5l-29,24.6l-30.7-25.5"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M395.7,533.6v-2.9h-54.4c-1.9,0-3.6-1-4.5-2.6l-0.3-0.1v4.7c0,0.2,0.1,0.3,0.2,0.5l0.1,0.1 c0.8,0.8,1.8,1.3,3,1.3h55C395.2,534.6,395.7,534.2,395.7,533.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M396.8,473.9l-4.1,39.9l0.3,15.8h-53c-1.2,0-2.2-1-2.2-2.2l0,0c0-0.9,0.6-1.7,1.4-2.1l24.3-11.4l-1.8-44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M363.2,511.7L338,525.2c-0.9,0.4-1.6,1.4-1.6,2.6l0,0c0,1.5,1.6,2.8,2.9,2.8h56.4l-2.6-17.2 C393.1,513.5,373.5,517.6,363.2,511.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 348.6,
    y1: 519.5,
    x2: 351.8,
    y2: 524.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 351.8,
    y1: 517.8,
    x2: 355,
    y2: 523
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 355,
    y1: 516,
    x2: 358.2,
    y2: 521.2
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M438.1,533.6v-2.9h54.4c1.9,0,3.6-1,4.5-2.6l0.3-0.1v4.7c0,0.2-0.1,0.3-0.2,0.5l-0.1,0.1 c-0.8,0.8-1.8,1.3-3,1.3h-55C438.6,534.6,438.1,534.2,438.1,533.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M432.6,473.9l5.6,39.9l2.6,15.8h53c1.2,0,2.2-1,2.2-2.2l0,0c0-0.9-0.6-1.7-1.4-2.1l-27.2-11.4l0.4-44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M467.8,511.7l28.1,13.5c0.9,0.4,1.6,1.4,1.6,2.6l0,0c0,1.5-1.6,2.8-2.9,2.8h-56.4l-0.2-17.2 C437.9,513.5,457.4,517.6,467.8,511.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 483.2,
    y1: 519.2,
    x2: 479.7,
    y2: 524.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 479.9,
    y1: 517.6,
    x2: 476.6,
    y2: 523
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 476.6,
    y1: 516,
    x2: 473.4,
    y2: 521.2
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M397.4,247.2c0,0-0.2,31,3.8,59s22.3,202.3,22.3,202.3h50.1c0,0-4.1-132.6-9.7-200.2 c-1.2-14.6-4.7-44-17.3-61.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M466.5,508.4c0,0-4.1-132.6-9.7-200.2c-1.2-14.6-4.7-44-17.3-61.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M355.2,254.5c-5.1,64.6,3.1,253.9,3.1,253.9h46.6l11.9-194.7c0,0,10.5-43.2,0.3-64.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M411.8,395.8c0,0-8.6-99-12.2-138.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 397.8,
    y1: 508.4,
    x2: 408.7,
    y2: 360.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M430.5,272.4c0,0-0.5,11.7,23.4,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M353.8,287.9c0,0,21.9-0.4,24.4-15.5"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M339.5,160.9c0,0-15.7,15.6-21.8,15c-10.1-1.1-66.6-42.5-66.6-42.5l-10.6,10.3c0,0,46.7,63.1,71.9,65.9 c21.8,2.5,51.1-23.6,51.1-23.6"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M396.8,130.9c0,0-20.8-4.2-41.2,10c-17.8,12.4-28,24.8-28,24.8l27.6,31.2l33-27.4"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M328.8,163.2c0,0,22.1,23.8,32.7,27.2c8.5,2.7,43-8.1,43-8.1l9.8,15c-8.3,4.6-49.3,28.5-71.8,15.5 c-18.8-10.8-35.9-26.5-35.9-26.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M395.9,185.9c4.1-2.1,9.8-4.7,13.8-6.9c2-1.1,6-3.3,6.8-2.7c1.6,1.1-4.3,4.1-3.2,5c0.6,0.5,4.8-2.1,6.8-3.5 c1.8-1.3,4-2.9,5.2-2.1c1,0.7-9.3,8.4-9.3,8.4s11.6-7.1,12.8-6.1c1.7,1.5-10.9,9.1-10.9,9.1s11.1-6.4,12.3-5.3 c1.3,1.1-7.5,6.1-10.7,8.4c2.2-1.1,9.9-5.6,10.9-4.8c0.9,0.8-2.7,3.9-3.6,4.5c-5.9,3.9-18.4,10.5-18.4,10.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M416.7,191.1c0,0-7.5-3.1-13,0.3"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M396.5,131.5c0,0-28.9,2.3-38.5,53.4c-4,21.6-5.3,87.6-5.3,87.6s55,3.6,107.5-0.1c0-22.1-6.2-77.6-12.4-105 c-4.2-18.6-21.7-28-36.1-36.6"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M391.4,88.8c-2.5,3.6-4,8.1-4.1,12.5c-0.1,3.4,0.9,7.1,3.7,8.8c1.1,0.7,2.6,1,3.7,0.2 c0.9-0.6,1.2-1.7,1.5-2.7c0.7-2.8,1.2-5.6,1.4-8.5c0.1-1.8,0.1-3.6-0.4-5.3s-1.4-3.4-2.9-4.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M394.7,119.1l-0.2,12.5c0,0,1,4.5,9.5,4.7c10.8,0.3,12.9-5.4,12.9-5.4l-2-23.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M393.5,105.4c-0.1-0.6-1-0.9-1.6-0.7c-0.9,0.3-1.6,1.1-1.9,2s-0.3,1.9-0.2,2.8c0.1,0.9,0.3,1.8,0.8,2.5 c0.9,1.3,2.8,1.6,4.2,0.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M392.6,93c0,0-2.5,21.4,1.1,25.2c5.3,5.7,14.4,4.2,18.5,0.6c3.4-3,6.2-16,5.7-19.4 C416.5,90.1,396.7,87.5,392.6,93z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M421,89.3c-1.1-2-1.2-4.7-2.5-6.7c-1.1-1.7-2.9-2.7-4.8-3c-2-0.3-4.1-0.1-5.9-0.9c-1.2-0.5-2.1-1.4-3.3-2 c-3.1-1.6-7.2-0.5-9.1,2.6c-0.3,0.5-0.6,1.1-1,1.5c-0.9,0.9-2.3,1-3.6,1.2c-1.5,0.3-3.7,1.3-4.4,3c-0.7,1.6-0.7,4,0.1,5.6 c1.3,2.8,3.6,2.8,6,3.5c4.3,1.2,8.2-0.5,12.5-0.7c1.8-0.1,4.8,0.1,6,1.6c1.9,2.3,2.5,5.3,2.8,8.2c0.4,3.2-1.1,8.9,1.2,11.4 c1.4-1,6.1-2.5,6.7-4.4c0.5-1.7,0-3.6,0.5-5.3c0.4-1.5,1.7-2.6,2.4-3.9c1.5-2.6,1.2-6.4-0.8-8.6c-0.7-0.9-1.7-1.5-2.4-2.4 C421.3,89.8,421.1,89.6,421,89.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M394.7,119.6c5.6,3.4,11.5,2.4,14.1,1.4c4.9-1.9,5.4-6.7,5.4-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M400.7,102.2c0,0-0.7,5.6-0.2,6.7c0.5,1.1,3.6,0.3,3.6,0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M406,103.8c0,0.5,0.3,1,0.7,1c0.4,0,0.8-0.4,0.8-0.9s-0.3-1-0.7-1C406.4,102.8,406,103.2,406,103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M394.5,102.8c0,0.5,0.3,1,0.7,1c0.4,0,0.8-0.4,0.8-0.9s-0.3-1-0.7-1C394.9,101.8,394.5,102.2,394.5,102.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M410.4,99.3c-0.1-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.4-0.1 c-1,0-2.1,0.1-3.1,0.4c-0.5,0.1-1,0.2-1.4,0.4c-0.6,0.3-0.5,0.3-0.2,0.8c0,0.1,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0,0.3,0 c1.6-0.5,3.4-0.6,5.1-0.4c0.1,0,0.2,0,0.2-0.1C410.4,99.5,410.4,99.4,410.4,99.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M393.6,98.9c0.1-0.2,0.3-0.5,0.4-0.7c0.1-0.1,0.1-0.2,0.2-0.2c0.1-0.1,0.2-0.1,0.3,0c0.8,0.1,1.6,0.2,2.4,0.5 c0.4,0.1,0.8,0.2,1.1,0.5c0.4,0.3,0.4,0.3,0.1,0.8c0,0.1-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0-0.2,0c-1.3-0.6-2.7-0.8-4-0.7 c-0.1,0-0.2,0-0.2-0.1C393.5,99,393.6,99,393.6,98.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M398.4,112.5h9.7c0,0,0.1,5.1-5.9,5.1C398.2,117.6,398.4,112.5,398.4,112.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M413,107.4c0.3-0.8,1.7-2,2.5-2s1.7,0.4,2.3,0.9c3.1,2.7,1,8.9-3.2,8.8c-1.6,0-1.4-2.1-1.4-2.1"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M356.5,195.7c0,0,3.1-32.2,7.8-41.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M453,193.3c0,0-3.8-29.8-8.6-38.8"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M219.4,143c0,0-25.1,16.7-41,10.9c-11.7-4.3-35.5-40-35.5-40l-18.5,7.9c4.8,9.4,28.1,63,57.1,65 c24.2,1.7,52.3-12.5,52.3-12.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M148.6,122.6c-2.5-4.5-6.2-10.5-8.5-15c-1.2-2.2-3.5-6.8-4.7-6.8c-2.2,0,1.4,6.5-0.1,6.6 c-0.9,0.1-3.2-4.9-4.2-7.5c-0.9-2.3-1.9-5.2-3.6-5.2c-1.4,0,3.4,13.6,3.4,13.6s-6.4-13.9-8.1-13.6c-2.5,0.3,4.5,15.3,4.5,15.3 s-6.3-12.9-8.2-12.6c-1.9,0.2,3.1,10.4,4.7,14.5c-1.4-2.4-5.8-11.4-7.1-11.2c-1.3,0.2,0.1,5.3,0.6,6.5c3,7.3,10.5,21.2,10.5,21.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M126.1,114.5c0,0,8.9,1.8,11.9,8.3"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "329.6,534.6 288.7,534.6 289,529.6 329.8,529.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "325.3,479.7 326.3,514.1 324.4,529.6 297.7,512.7 294.5,475.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M297.7,512.7c0,0-5.5,9.9-7.3,12.6c-1.8,2.8-1.5,5.4-1.5,5.4s38.7,0,40.9,0c0.7-4.2-3.4-18-3.4-18 S305.3,514.1,297.7,512.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 306.3,
    y1: 516,
    x2: 316.1,
    y2: 516
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 305.9,
    y1: 519.3,
    x2: 316.3,
    y2: 519.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 305.5,
    y1: 522.6,
    x2: 316.7,
    y2: 522.6
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268,533.6l0.2-2.9h-54.4c-1.9,0-3.5-1-4.4-2.6l-0.3-0.1l-0.2,4.7c0,0.2,0,0.3,0.2,0.5l0.1,0.1 c0.7,0.8,1.8,1.3,2.9,1.3h55C267.5,534.6,268,534.2,268,533.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M266.2,479.7l-0.1,34.1l-0.5,15.8h-53c-1.2,0-2.2-1-2.1-2.2l0,0c0-0.9,0.7-1.7,1.5-2.1l24.9-11.4l-5.6-38.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M236.7,511.7l-25.9,13.5c-1,0.4-1.6,1.4-1.7,2.6l0,0c-0.1,1.5,1.4,2.8,2.8,2.8h56.4l-1.7-17.2 C266.5,513.5,246.7,517.6,236.7,511.7z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 222.2,
    y1: 519.3,
    x2: 225.5,
    y2: 525.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 226.4,
    y1: 517.1,
    x2: 229.8,
    y2: 523.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 230.7,
    y1: 514.9,
    x2: 234.1,
    y2: 521.2
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M243.9,222.7l-9,4.4l-4.6,14.2c-7.4,11.4-18.5,34-17.4,65.8c1.7,47.3,17.1,187.1,17.1,187.1h38.5l1.8-213.5 l-0.2-74"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M299.8,225.2c0,0,1.9,5.2,4.7,13.3c7.7,9.2,18.3,25,22.5,46.2c8.2,42.3,3.5,209.5,3.5,209.5H293l-30.9-214.4 c0,0-5.3-18.1-3.7-48.3"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M269.7,332.8c-2.2-22.6-10.1-59-10.5-86.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M230.3,241.3c0,0,22.3,12,74.2-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M253.4,245.8H252c-1.6-0.1-2.8-1.5-2.6-3.2l0.5-4.7c0.2-1.6,1.6-2.8,3.1-2.8h2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M256.6,240.7c-0.1,1.2-0.9,2.2-1.9,2.2s-1.8-1-1.7-2.2s0.9-2.2,1.9-2.2C255.9,238.6,256.6,239.5,256.6,240.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M282.8,243.6c0-0.4-2.3-10.8-2.3-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M236.8,243.6c-0.3-0.3,3.6-11.3,3.6-11.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M297.4,240.5c0,0,13,15,18.1,41.7s7.9,212.1,7.9,212.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M278.3,244.3c0,0,1,10.8,25.6,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M226.4,247.9c0,0,11.3,5.3,14.9-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M252,245.8c0,0-0.1,25.5,2,27.7s8.1,3.2,8.1,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M265.6,492.6c0,0-2.7-160,0.1-189.3"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M308.7,158.9c-5-7.5-32.7-24.3-32.7-24.3c-8.7-1.1-18.6-0.8-18.6-0.8s-11.2,12.1-20.7,25.7 c-7.9,7.9-8.8,17.8-8.6,26c0.2,11.6,4.3,28.4,5.2,46.8c15.9,5.8,45.7,4.4,68.3-2C301.5,230.3,313.8,166.4,308.7,158.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M257.4,133.8c0,0-15.3-3.3-38.1,7.8c-17.2,8.4-20,10.3-20,10.3l13.3,32.6l37.2-16.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M251.1,133.4c-2.6,2.9-12.1,6.4-13.3,5.8c-1.2-0.6,2.4-3.5,2.9-4.3c-3,0.1-5.6,0.7-7.5,1.4 c-2.4,0.8-5,1.5-7.4,2.4c1.6-2.3,5.3-5.3,6.7-5.9C238.2,130.2,245.6,130.1,251.1,133.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M291.9,175.7l23.9,21l22.9-24.1c0,0-11.4-11.6-22.1-22.2c-20.9-20.9-40.5-15.7-40.5-15.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 308,
    y1: 189.9,
    x2: 293.7,
    y2: 177.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M228.6,177c0,0,1.3-10.7,8.1-17.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 204.7,
    y1: 148.9,
    x2: 217.7,
    y2: 182.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st29",
    x1: 311.9,
    y1: 193.3,
    x2: 334.3,
    y2: 168.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M255.2,133.8c0,0-3.7,9.1,8.4,9.8c14.1,0.9,15.5-9.1,15.5-9.1"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M258.3,121.2l-0.9,13.9c0,0-1,5.8,7.9,5.8c8,0,10.8-6.2,10.8-6.2l-2.3-20.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st5",
    d: "M253.3,89.3c-3.8,8.4-9.4,26.1,0,33c2.2,1.6,5.7,1.8,9.5,0.8c8.2-2.2,13.9-7.8,16-13.1 C281.3,103.3,266.3,75.9,253.3,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M253.8,115.1l9.4-0.6c0,0-1.4,4.7-5.6,4.7C253.5,119.2,253.8,115.1,253.8,115.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M288,92.7c1.2,1.4,2.7,2.5,4.9,3.2c3.5,1.1,5.7,1.8,7.6,5.2c2,3.3,1.6,9.1,5.2,10.8c3.5,1.6,7.7-0.2,10,3.8 c-1.2,4.7-9.3,17.3-12.4,21.6c-2.7-2.7-3.9-3.2-6.8-3.9c-2.3-0.5-4.7-0.2-6.9-0.9c-2-0.7-3.7-2.2-4.9-4c-0.7-1.2-1.3-2.5-2.3-3.5 c-1.4-1.4-3.3-2.1-5.2-2.6c-1.2-0.3-2.5-0.6-3.5-1.3c-2.3-1.6-2.9-4.4-3.1-7c-0.2-3.3-0.2-6.7-0.2-10c0-3.6-3.4-5.3-5.5-7.7 c-0.3-0.3-4.1-5.6-3.4-5.9c-3.4,1.3-9.6,3.5-12.2,6c-3-6.9,2.5-15,10.4-14.5c1.1,0.1,3.3-1.4,4.6-1.6c1.6-0.3,3.3-0.4,5-0.3 c3.4,0.2,6.7,1.2,9.7,2.8c2.3,1.3,5.3,3.1,6.5,5.6C286.2,90.2,287,91.6,288,92.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_401_",
    className: "st9",
    d: "M257.1,103.9c0,0-4.3,5.2-3.8,6.6c0.6,1.4,3.6,1.2,3.6,1.2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_399_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    className: "st8",
    d: "M263.4,104.9c0,0.1,0.1,0.2,0.1,0.3c0.2,0.7,0.1,1.2,0,1.9c-0.1,1.1-1.9,0.7-1.6-0.4 c0.2-0.7,0.3-1.4,0.7-1.9C262.9,104.2,263.2,104.5,263.4,104.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_395_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_397_",
    className: "st8",
    d: "M253.1,101.8c0,0.1,0,0.2,0.1,0.3c0.1,0.7-0.2,1.2-0.4,1.9c-0.3,1-2,0.3-1.5-0.7 c0.3-0.6,0.6-1.3,1.1-1.8C252.7,101.1,252.9,101.4,253.1,101.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_391_",
    className: "st8",
    d: "M267.6,104.7c0,0,0.1-0.5-0.1-1.3s-0.7-1.7-1.5-2.4s-1.9-1.1-2.7-1c-0.4,0-0.7,0.2-0.9,0.2 c-0.2,0.1-0.3,0.2-0.3,0.2s0.1,0,0.3,0.1c0.2,0,0.5,0.2,0.8,0.3c0.6,0.3,1.3,0.7,1.9,1.3c0.6,0.5,1.2,1.1,1.7,1.7 c0.2,0.3,0.4,0.5,0.6,0.6C267.5,104.6,267.6,104.7,267.6,104.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_385_",
    className: "st8",
    d: "M256.1,99.3c0,0,0-0.1-0.1-0.3c-0.1-0.1-0.2-0.4-0.4-0.6c-0.4-0.5-1.3-0.7-2.1-0.6 c-0.8,0.1-1.5,0.5-1.9,1s-0.4,0.9-0.4,0.9s0.1,0,0.3-0.1c0.1-0.1,0.4-0.1,0.6-0.1c0.5-0.1,1-0.2,1.6-0.2c0.6-0.1,1.1-0.1,1.5-0.1 C255.6,99.2,256.1,99.3,256.1,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M269.5,120.5c0,0-4.6,3.6-11.4,3.6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_376_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.3,109c1.2-3.3,4.6-2.2,5.5-1.4c0.6,0.6,0.8,1.5,0.7,2.4c-0.1,2.1-1.1,4.2-2.8,5.5c-0.6,0.5-1.3,0.9-2,1 c-2.1,0.3-3.2-1.4-3-3.2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome01);
export default __webpack_public_path__ + "static/media/welcome-01.b07e1c0eb275c4c6791338045d3f832f.svg";
export { ForwardRef as ReactComponent };